import { css } from 'styled-components';
import { body1, body2, colors, duration, easing, fontWeights } from 'ui/theme';
import { SideNavLinkConfig, SideNavSectionConfig } from './types';

export const getSideNavAnchorTagStyles = (isActive?: boolean, isSubLink?: boolean) => css`
  ${isSubLink ? body2 : body1};
  color: ${isActive ? colors.textLink : colors.textSecondary};
  font-weight: ${isActive ? fontWeights.medium : fontWeights.regular};
  text-decoration: ${isSubLink ? 'underline' : 'none'};
  transition: all ${easing.exit} ${duration.short};

  &:hover {
    color: ${isActive ? colors.textLink : colors.textPrimary};
    transition: all ${easing.entrance} ${duration.short};
  }
`;

export const isSection = (
  linkOrSection: SideNavLinkConfig | SideNavSectionConfig,
): linkOrSection is SideNavSectionConfig => 'header' in linkOrSection;
